import React from 'react'
import { Helmet } from 'react-helmet'
import data from '../FakeData/index.json'

function SeoHelmet({ pageName, description, keywords }) {
    if (keywords === undefined) {
        keywords = `coding, blog, react, react js, python, python3, django, restful api, developer, developement, flutter, next, next js, react.js, next.js, python 3, server, deployment, java, javascript, dev, hashnode, blogging`;
    }
    if (description === undefined) {
        description = `I am a Software Developer who likes to write Technical Blogs and contribute to Open Source.
The Blog content will be mostly about Technical guide and my recent learnings and experience.`;
    }
    return (
        <Helmet>
            <title>
                {pageName} | {data[0].name} - Blogs for Developers
            </title>
            <meta name='description' content={description} />
            <meta name='keywords' content={keywords} />
            <meta property="og:site_name" content="Down the Code | Blog for Developers" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content='https://downthecode.netlify.app' />
            <meta property="og:description" content={description} />
            <meta property="og:title" content={pageName} />
        </Helmet>
    )
}

export default SeoHelmet
